import { render, staticRenderFns } from "./PhysicianDuty.vue?vue&type=template&id=6ad2f9d4&scoped=true&"
import script from "./PhysicianDuty.vue?vue&type=script&lang=js&"
export * from "./PhysicianDuty.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianDuty.vue?vue&type=style&index=0&id=6ad2f9d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad2f9d4",
  null
  
)

export default component.exports